<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.5 22.58594">
		<g>
			<path d="M16.40332 7.15674a.74671.74671 0 0 1-.53027-.21973l-5.12647-5.12646-5.12646 5.12646a.74992.74992 0 0 1-1.06055-1.06054L10.21631.21973a.74973.74973 0 0 1 1.06055 0l5.65673 5.65674a.75.75 0 0 1-.53027 1.28027Z"/>
			<path d="M10.75 14.83594a.7502.7502 0 0 1-.75-.75v-11.5a.75.75 0 0 1 1.5 0v11.5a.7502.7502 0 0 1-.75.75Z"/>
		</g>
		<path fill="currentColor" d="M20.75 22.58594h-20a.7502.7502 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v5.25H20v-5.25a.75.75 0 0 1 1.5 0v6a.7502.7502 0 0 1-.75.75Z"/>
	</svg>
</template>
